export enum PricePlanRemoveTypeEnum {
  from_offer = 'from_offer',
  from_account = 'from_account',
}
